const CASES = [
  {
    num: "Case Study 01",
    stat: "$16,000+ Recovered",
    situation: "A Georgia law firm was paying an outside marketing agency for recurring content services.",
    review: "Eight months of invoices and contracted deliverables were compared.",
    finding: "Charges were identified for content that was not delivered according to the agreed schedule or scope.",
    result: "More than $16,000 was recovered by the firm.",
  },
  {
    num: "Case Study 02",
    stat: "Approximately $8,000 Recovered",
    situation: "A Georgia law firm purchased leads from an outside lead-generation provider.",
    review: "Lead records and qualification criteria were compared against billed activity.",
    finding: "Hang-ups and other nonqualified calls had been classified and billed as qualified leads.",
    result: "Approximately $8,000 was recovered.",
  },
];

const STEPS = [
  ["Situation", "situation"],
  ["Review", "review"],
  ["Finding", "finding"],
  ["Result", "result"],
];

export function ClientOutcomes() {
  return (
    <section id="client-outcomes" className="relative z-10 border-t border-white/10 bg-[#0B1F33] scroll-mt-24" data-testid="client-outcomes">
      <div className="max-w-7xl mx-auto px-6 py-20 sm:py-24">
        <p className="font-mono-data text-xs uppercase tracking-[0.25em] text-[#D5A44A] mb-4">Client outcomes</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight max-w-3xl">
          What an independent review can surface.
        </h2>
        <div className="mt-12 grid lg:grid-cols-2 gap-6">
          {CASES.map((c) => (
            <div key={c.num} className="border border-white/10 bg-[#12324D] p-8 flex flex-col" data-testid="outcome-card">
              <p className="font-mono-data text-[10px] uppercase tracking-widest text-[#0E7C7B]">{c.num}</p>
              <p className="font-display text-4xl sm:text-5xl text-[#D5A44A] mt-3 leading-none">{c.stat}</p>
              <div className="mt-7 space-y-4">
                {STEPS.map(([label, key]) => (
                  <div key={key} className="border-l-2 border-[#D5A44A]/30 pl-4">
                    <p className="font-mono-data text-[10px] uppercase tracking-widest text-zinc-500">{label}</p>
                    <p className="mt-1 text-sm text-zinc-300 leading-relaxed">{c[key]}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <p className="mt-8 text-xs text-zinc-500 max-w-3xl leading-relaxed" data-testid="outcomes-disclaimer">
          Client identities are withheld to protect confidentiality. Results reflect individual engagements and are not guarantees of future findings, savings or recoveries.
        </p>
      </div>
    </section>
  );
}
